<template>
  <div class="benchmark">
    <div class="benchmark__head">
      <span>{{ label }}</span>
      <span class="benchmark__mine">
        <hb-money v-if="money" :cents="mine" size="sm" />
        <template v-else>{{ format(mine) }}{{ suffix }}</template>
      </span>
    </div>

    <div class="benchmark__track">
      <div class="benchmark__fill" :style="{ width: `${minePct}%` }" />
      <!-- Marca da média: uma régua sobre a mesma barra deixa a comparação imediata,
           sem exigir duas barras e a leitura de qual é qual. -->
      <div class="benchmark__average" :style="{ left: `${averagePct}%` }" />
    </div>

    <div class="benchmark__hint">
      {{ $t('influencer_panel.platform_average') }}:
      <hb-money v-if="money" :cents="average" size="sm" />
      <template v-else>{{ format(average) }}{{ suffix }}</template>
    </div>
  </div>
</template>

<script>
import HbMoney from '@/components/hubee/HbMoney.vue'

/**
 * Uma métrica do influencer contra a média da plataforma.
 *
 * A escala é o maior dos dois valores com folga, para que quem está muito acima da média
 * não estoure a barra e quem está abaixo ainda enxergue a própria posição.
 */
export default {
  name: 'BenchmarkBar',
  components: { HbMoney },
  props: {
    label: { type: String, required: true },
    mine: { type: Number, default: 0 },
    average: { type: Number, default: 0 },
    money: { type: Boolean, default: false },
    suffix: { type: String, default: '' },
  },
  computed: {
    scale() {
      return Math.max(Number(this.mine || 0), Number(this.average || 0), 1) * 1.15
    },
    minePct() {
      return Math.min(100, Math.round((Number(this.mine || 0) / this.scale) * 100))
    },
    averagePct() {
      return Math.min(100, Math.round((Number(this.average || 0) / this.scale) * 100))
    },
  },
  methods: {
    format(value) {
      return Number(value || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 })
    },
  },
}
</script>

<style scoped>
.benchmark__head {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  font-size: 0.9rem;
  font-weight: var(--fw-medium);
  color: var(--text-heading);
  margin-bottom: 0.4rem;
}

.benchmark__track {
  position: relative;
  height: 8px;
  border-radius: var(--radius-pill);
  background: var(--surface-sunken);
}

.benchmark__fill {
  height: 100%;
  border-radius: var(--radius-pill);
  background: var(--primary);
}

.benchmark__average {
  position: absolute;
  top: -3px;
  width: 2px;
  height: 14px;
  background: var(--text-muted);
  border-radius: 1px;
}

.benchmark__hint {
  margin-top: 0.3rem;
  font-size: var(--fs-xs);
  color: var(--text-muted);
}
</style>
